/* Presentation only: mark short field labels inside universal 01 accordions. */
(() => {
  'use strict';

  if (window.BPLAccordionHighlights) {
    window.BPLAccordionHighlights.init(document);
    return;
  }

  const scopeSelector = '.bpl-product-content--01';
  const labelClass = 'bpl-detail-label';
  const boundaries = new Set(['P', 'LI', 'DIV', 'UL', 'OL', 'DL', 'DT', 'DD', 'BLOCKQUOTE', 'TABLE', 'TBODY', 'THEAD', 'TFOOT', 'TR', 'TD', 'TH']);
  const excluded = new Set(['A', 'CODE', 'PRE', 'KBD', 'SAMP', 'SCRIPT', 'STYLE', 'FORM', 'TEXTAREA', 'BUTTON', 'INPUT', 'SELECT', 'OPTION', 'SVG', 'MATH', 'IFRAME', 'VIDEO', 'AUDIO', 'CANVAS']);

  function labelRange(text) {
    const start = text.search(/\S/u);
    const colon = text.indexOf(':');
    if (start < 0 || colon <= start) return null;
    const label = text.slice(start, colon).trim();
    const words = label.split(/\s+/u);
    if (Array.from(label).length > 72 || words.length > 9 || !/\p{L}/u.test(label)) return null;
    if (/[.!?;]/u.test(label)) return null;
    // A scheme or clock/ratio separator is content, not a field label.
    if (/^(?:https?|ftp|mailto|tel|data|urn|file|javascript):/iu.test(text.slice(start))) return null;
    if (text.slice(colon + 1, colon + 3) === '//') return null;
    if (/\d/u.test(text[colon - 1]) && /\d/u.test(text[colon + 1] || '')) return null;
    return { start, end: colon + 1 };
  }

  function highlightLine(parts) {
    if (!parts.length) return;
    const text = parts.map(part => part.text).join('');
    const range = labelRange(text);
    if (!range) return;
    let offset = 0;
    const selected = [];
    for (const part of parts) {
      const end = offset + part.text.length;
      // Zero-width interactive/media nodes also prevent crossing a prefix.
      const intersects = part.text.length > 0 && end > range.start && offset < range.end;
      if (part.blocked && (intersects || (!part.text.length && offset >= range.start && offset < range.end))) return;
      if (intersects) selected.push({ node: part.node, start: Math.max(0, range.start - offset), end: Math.min(part.text.length, range.end - offset) });
      offset = end;
    }
    for (const part of selected) {
      let textNode = part.node;
      // Split only text nodes. Existing inline elements, links and their event
      // listeners stay in place; no HTML parsing, cloning or replacement occurs.
      if (part.end < textNode.data.length) textNode.splitText(part.end);
      if (part.start > 0) textNode = textNode.splitText(part.start);
      const span = textNode.ownerDocument.createElement('span');
      span.className = labelClass;
      textNode.parentNode.insertBefore(span, textNode);
      span.appendChild(textNode);
    }
  }

  function highlightDetails(details) {
    let line = [];
    function flush() {
      highlightLine(line);
      line = [];
    }
    function visit(node) {
      if (node.nodeType === 3) {
        line.push({ node, text: node.data, blocked: false });
        return;
      }
      if (node.nodeType !== 1) return;
      const tag = node.tagName;
      if (tag === 'SUMMARY' || tag === 'DETAILS' || /^H[1-6]$/u.test(tag)) {
        flush();
        return;
      }
      if (tag === 'BR' || tag === 'HR') {
        flush();
        return;
      }
      if (excluded.has(tag) || node.hasAttribute('contenteditable') || node.classList.contains(labelClass)) {
        line.push({ node, text: node.textContent, blocked: true });
        return;
      }
      const boundary = boundaries.has(tag);
      if (boundary) flush();
      // Snapshot children: highlighting a preceding line may insert spans.
      Array.from(node.childNodes).forEach(visit);
      if (boundary) flush();
    }
    Array.from(details.childNodes).forEach(visit);
    flush();
  }

  function init(root = document) {
    const scopes = [];
    if (root.matches && root.matches(scopeSelector)) scopes.push(root);
    if (root.querySelectorAll) scopes.push(...root.querySelectorAll(scopeSelector));
    scopes.forEach(scope => {
      scope.querySelectorAll('details').forEach(details => {
        // Never process content nested in an excluded interactive/code area.
        if (details.closest('a, pre, code, form, [contenteditable]')) return;
        highlightDetails(details);
      });
    });
  }

  window.BPLAccordionHighlights = { init };
  document.addEventListener('shopify:section:load', event => init(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
})();
